import { useState, useEffect } from "react";

function getOrientation(): "portrait" | "landscape" {
  // Best: matchMedia
  if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
  if (window.matchMedia("(orientation: landscape)").matches) return "landscape";

  // Fallback: compare width/height
  // The reason we have falback is because in some browsers, the orientation is not detected correctly.
  // or not supported. This fallback gives orientation if css media query is not supported.
  return window.innerHeight >= window.innerWidth ? "portrait" : "landscape";
}

export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<"portrait" | "landscape">(getOrientation);

  useEffect(() => {
    const handleChange = () => setOrientation(getOrientation());

    // Android / Chrome
    if (window.screen.orientation?.addEventListener) {
      window.screen.orientation.addEventListener("change", handleChange);
    }

    // iOS / Safari fallback
    window.addEventListener("resize", handleChange);

    return () => {
      if (window.screen.orientation?.removeEventListener) {
        window.screen.orientation.removeEventListener("change", handleChange);
      }
      window.removeEventListener("resize", handleChange);
    };
  }, []);

  return orientation;
};
